// extracted by mini-css-extract-plugin
module.exports = {"About":"About_About__2X68g","box":"About_box__386af","partnerBox":"About_partnerBox__3udgm","DataProviderLogo":"About_DataProviderLogo__VuhbT"};